import { graphql } from "@leplein/graphql-public/clients/graphql-qrcode-client";

export const GetChargingPoolOffersQuery = graphql(`
  query GetChargingPoolOffers($input: ChargingPoolOffersInput!) {
    chargingPoolOffers(input: $input) {
      offers {
        type
        maxElectricPower {
          value
          unit
        }
        priceInclVat {
          amountInCents
          currency
        }
        slots {
          name
          cpoPaymentUrl
        }
      }
    }
  }
`);
